<!-- Skeleton Loader -->
<div *ngIf="cargando">
  <!-- Versión Web -->
  <div class="web">
    <div class="efemerides-container skeleton-container">
      <div class="efemerides-center">
        <div class="container-fluid">
          <div class="skeleton-title"></div>
          <div class="skeleton-date"></div>

          <div class="efemerides-slider-wrapper">
            <div class="efemerides-grid">
              <div class="efemeride-card skeleton-card" *ngFor="let item of [1,2,3]">
                <div class="skeleton-thumbnail-loading"></div>
                <div class="efemeride-info">
                  <div class="skeleton-text skeleton-fecha"></div>
                  <div class="skeleton-text skeleton-titulo"></div>
                  <div class="skeleton-text skeleton-descripcion"></div>
                  <div class="skeleton-text skeleton-descripcion-short"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Indicadores skeleton -->
          <div class="slider-indicators skeleton-indicators">
            <button class="skeleton-indicator"></button>
            <button class="skeleton-indicator"></button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Versión Móvil -->
  <div class="movil">
    <div class="efemerides-container-m skeleton-container-m">
      <div class="efemerides-center-m">
        <div class="container-fluid">
          <div class="skeleton-title-m"></div>
          <div class="skeleton-date-m"></div>

          <div class="efemeride-slide-m">
            <div class="efemeride-card-m skeleton-card">
              <div class="skeleton-thumbnail-loading-m"></div>
              <div class="efemeride-info-m">
                <div class="skeleton-text skeleton-fecha-m"></div>
                <div class="skeleton-text skeleton-titulo-m"></div>
                <div class="skeleton-text skeleton-descripcion-m"></div>
                <div class="skeleton-text skeleton-descripcion-short-m"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Contenido Real -->
<div *ngIf="!cargando && efemerides.length > 0">
  <!-- Versión Web -->
  <div class="web">
    <div class="efemerides-container">
      <div class="efemerides-center">
        <div class="container-fluid">
          <h2 class="efemerides-titulo-principal">
            <span *ngIf="!esFechaFiltrada">Un día como hoy... </span>
            <span *ngIf="esFechaFiltrada">Un día como el </span>
            <span class="efemerides-fecha-actual">{{ fechaActual }}</span>
          </h2>

          <div class="titulo-con-calendario">
            <button class="btn-toggle-calendario" (click)="toggleCalendario()" title="Buscar por fecha">
              <i class="fas fa-calendar-alt"></i>
              Buscar fecha
            </button>
            <div class="share-menu-wrapper">
              <button class="btn-share-dots" (click)="toggleShareMenu()" title="Compartir">
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <div class="share-dropdown" *ngIf="mostrarShareMenu">
                <span class="share-dropdown-label">Compartir en:</span>
                <div class="share-dropdown-icons">
                  <button class="share-icon-btn facebook" (click)="compartirResumenFacebook()" title="Facebook">
                    <i class="fab fa-facebook-f"></i>
                  </button>
                  <button class="share-icon-btn twitter" (click)="compartirResumenTwitter()" title="X">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
                  </button>
                  <button class="share-icon-btn whatsapp" (click)="compartirResumenWhatsapp()" title="WhatsApp">
                    <i class="fab fa-whatsapp"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Calendario desplegable -->
            <div class="calendario-wrapper" *ngIf="mostrarCalendario">
              <app-calendario-efemerides
                [fechaInicial]="calendarioFechaSeleccionada"
                (fechaSeleccionada)="onFechaSeleccionada($event)">
              </app-calendario-efemerides>
            </div>
          </div>

          <div class="efemerides-slider-wrapper"
               (mouseenter)="pauseAutoSlide()"
               (mouseleave)="resumeAutoSlide()">
            <!-- Botón anterior -->
            <button class="slider-nav prev" (click)="onPrevClick()" *ngIf="slideGroups.length > 1">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="white" width="16" height="16"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>
            </button>

            <!-- Contenedor del slider -->
            <div class="efemerides-slider">
              <div class="efemerides-track"
                   [style.transform]="'translateX(-' + (currentSlide * 100) + '%)'">
                <div class="efemerides-slide" *ngFor="let slideGroup of slideGroups; let i = index">
                  <div class="efemerides-grid">
                    <div class="efemeride-card"
                         *ngFor="let efemeride of slideGroup">
                      <!-- Thumbnail de la imagen -->
                      <div class="efemeride-thumbnail"
                           [routerLink]="getRouterLink(efemeride)"
                           style="cursor: pointer;">
                        <ng-container *ngIf="!shouldShowSkeleton(efemeride.activoId)">
                          <img *ngIf="getProtectedImageUrl(efemeride.activoId)"
                               [src]="getProtectedImageUrl(efemeride.activoId)"
                               [alt]="efemeride.titulo"
                               class="thumbnail-image">
                        </ng-container>
                        <div *ngIf="shouldShowSkeleton(efemeride.activoId)" class="skeleton-thumbnail"></div>
                        <!-- Badge "Hace X años" -->
                        <div class="years-ago-badge">
                          <span class="badge-text" style="color: white;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="white" width="14" height="14" style="flex-shrink: 0;"><path d="M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>
                            {{ getYearsAgoText(efemeride.anio) }}
                          </span>

                          <div class="tail left">
                            <div class="outer"></div>
                            <div class="inner-fold"></div>
                          </div>

                          <div class="tail right">
                            <div class="outer"></div>
                            <div class="inner-fold"></div>
                          </div>
                        </div>
                      </div>

                      <!-- Información de la efeméride -->
                      <div class="efemeride-info">
                        <div [routerLink]="getRouterLink(efemeride)" style="cursor: pointer;">
                          <p class="efemeride-fecha">{{ efemeride.dia }}/{{ efemeride.mes }}/{{ efemeride.anio }}</p>
                          <h3 class="efemeride-titulo">{{ efemeride.titulo }}</h3>
                          <p class="efemeride-descripcion">{{ efemeride.descripcion }}</p>
                        </div>

                        <!-- Botones de compartir -->
                        <div class="share-buttons" (click)="$event.stopPropagation()">
                          <span class="share-label">Compartir:</span>
                          <button class="btn-share btn-share-facebook"
                                  (click)="sharedFacebook(efemeride); $event.preventDefault()"
                                  title="Compartir en Facebook"
                                  aria-label="Compartir en Facebook">
                            <i class="fab fa-facebook-f"></i>
                          </button>
                          <button class="btn-share btn-share-twitter"
                                  (click)="sharedTwitter(efemeride); $event.preventDefault()"
                                  title="Compartir en X"
                                  aria-label="Compartir en X">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                            </svg>
                          </button>
                          <button class="btn-share btn-share-whatsapp"
                                  (click)="sharedWhatsapp(efemeride); $event.preventDefault()"
                                  title="Compartir en WhatsApp"
                                  aria-label="Compartir en WhatsApp">
                            <i class="fab fa-whatsapp"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Botón siguiente -->
            <button class="slider-nav next" (click)="onNextClick()" *ngIf="slideGroups.length > 1">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="white" width="16" height="16"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5-12.5-32.8-12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg>
            </button>
          </div>

          <!-- Indicadores -->
          <div class="slider-indicators" *ngIf="slideGroups.length > 1">
            <button *ngFor="let slide of slideGroups; let i = index"
                    [class.active]="i === currentSlide"
                    (click)="goToSlide(i)">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Versión Móvil -->
  <div class="movil">
    <div class="efemerides-container-m">
      <div class="efemerides-center-m">
        <div class="container-fluid">
          <h2 class="efemerides-titulo-principal-m">
            <span *ngIf="!esFechaFiltrada">Un día como hoy... </span>
            <span *ngIf="esFechaFiltrada">Un día como el </span>
            <span class="efemerides-fecha-actual-m">{{ fechaActual }}</span>
          </h2>

          <div class="titulo-con-calendario-m">
            <button class="btn-toggle-calendario-m" (click)="toggleCalendario()" title="Buscar por fecha">
              <i class="fas fa-calendar-alt"></i>
            </button>
            <div class="share-menu-wrapper">
              <button class="btn-share-dots-m" (click)="toggleShareMenu()" title="Compartir">
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <div class="share-dropdown share-dropdown-m" *ngIf="mostrarShareMenu">
                <span class="share-dropdown-label">Compartir en:</span>
                <div class="share-dropdown-icons">
                  <button class="share-icon-btn facebook" (click)="compartirResumenFacebook()" title="Facebook">
                    <i class="fab fa-facebook-f"></i>
                  </button>
                  <button class="share-icon-btn twitter" (click)="compartirResumenTwitter()" title="X">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
                  </button>
                  <button class="share-icon-btn whatsapp" (click)="compartirResumenWhatsapp()" title="WhatsApp">
                    <i class="fab fa-whatsapp"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Calendario desplegable móvil -->
            <div class="calendario-wrapper-m" *ngIf="mostrarCalendario">
              <app-calendario-efemerides
                [fechaInicial]="calendarioFechaSeleccionada"
                (fechaSeleccionada)="onFechaSeleccionada($event)">
              </app-calendario-efemerides>
            </div>
          </div>

          <div class="carousel-touch-wrapper"
               (touchstart)="onTouchStart($event)"
               (touchmove)="onTouchMove($event)"
               (touchend)="onTouchEnd($event)">
            <mdb-carousel [animation]="'fade'" [interval]="5000" #mobileCarousel>
              <mdb-carousel-item *ngFor="let efemeride of efemerides; let i = index">
                <div class="efemeride-slide-m">
                  <div class="efemeride-card-m">
                    <!-- Thumbnail de la imagen -->
                    <div class="efemeride-thumbnail-m"
                         [routerLink]="getRouterLink(efemeride)"
                         style="cursor: pointer;">
                      <ng-container *ngIf="!shouldShowSkeleton(efemeride.activoId)">
                        <img *ngIf="getProtectedImageUrl(efemeride.activoId)"
                             [src]="getProtectedImageUrl(efemeride.activoId)"
                             [alt]="efemeride.titulo"
                             class="thumbnail-image-m">
                      </ng-container>
                      <div *ngIf="shouldShowSkeleton(efemeride.activoId)" class="skeleton-thumbnail-m"></div>
                      <!-- Badge "Hace X años" -->
                      <div class="years-ago-badge-m">
                        <span class="badge-text" style="color: white;">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="white" width="13" height="13" style="flex-shrink: 0;"><path d="M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>
                          {{ getYearsAgoText(efemeride.anio) }}
                        </span>

                        <div class="tail left">
                          <div class="outer"></div>
                          <div class="inner-fold"></div>
                        </div>

                        <div class="tail right">
                          <div class="outer"></div>
                          <div class="inner-fold"></div>
                        </div>
                      </div>
                    </div>

                    <!-- Información de la efeméride -->
                    <div class="efemeride-info-m">
                      <div [routerLink]="getRouterLink(efemeride)" style="cursor: pointer;">
                        <p class="efemeride-fecha-m">{{ efemeride.dia }}/{{ efemeride.mes }}/{{ efemeride.anio }}</p>
                        <h3 class="efemeride-titulo-m">{{ efemeride.titulo }}</h3>
                        <p class="efemeride-descripcion-m">{{ efemeride.descripcion }}</p>
                      </div>

                      <!-- Botones de compartir móvil -->
                      <div class="share-buttons-m" (click)="$event.stopPropagation()">
                        <span class="share-label-m">Compartir:</span>
                        <button class="btn-share-m btn-share-facebook-m"
                                (click)="sharedFacebook(efemeride); $event.preventDefault()"
                                title="Compartir en Facebook"
                                aria-label="Compartir en Facebook">
                          <i class="fab fa-facebook-f"></i>
                        </button>
                        <button class="btn-share-m btn-share-twitter-m"
                                (click)="sharedTwitter(efemeride); $event.preventDefault()"
                                title="Compartir en X"
                                aria-label="Compartir en X">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="15" height="15">
                            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                          </svg>
                        </button>
                        <button class="btn-share-m btn-share-whatsapp-m"
                                (click)="sharedWhatsapp(efemeride); $event.preventDefault()"
                                title="Compartir en WhatsApp"
                                aria-label="Compartir en WhatsApp">
                          <i class="fab fa-whatsapp"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </mdb-carousel-item>
            </mdb-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
